import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Select,
  Button,
  Modal,
  Descriptions,
  Empty,
  Input,
} from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
const { RangePicker } = DatePicker;
const { Option } = Select;
import { Card, Space } from "antd";
import { useLeaveBalancePageState } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Col, Row, Statistic, Tooltip, Checkbox } from "antd";
import { applyLeave, getCheckInStatus } from "./api";
import secureLocalStorage from "react-secure-storage";
import dayjs from "dayjs";
import { Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import ClockOutConfirm from "modules/all_authentication_pop_ups/clock_out_confirm/ClockOutConfirm.";
import moment from "moment";
const { TextArea } = Input;

const LeaveTracker = () => {
  // Using Toast to show notification
  const { setToaster } = useToast();

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [comments, setComments] = useState("");
  const [toggleWfh, setToggleWfh] = useState(false);
  const [modalShown, setModalShown] = useState(false);

  // Defining State
  const [requestLeaveRange, setRequestLeaveRange] = useState(null);

  // Importing required zustand State
  const {
    isLoading,
    setIsLoading,
    isUserCheckedInData,
    updateIsUserCheckedInData,
    selectedLeave,
    setSelectedLeave,
    leaveData,
    fetchLeaveFunc,
    getUserCheckedInStatusFunc,
    userCheckedInOutFunc,
    isLeaveModalOpen,
    setLeaveModalToggle,
    isCheckInOutModalOpen,
    setCheckInOutModalToggle,
  } = useLeaveBalancePageState();

  const onChangeToggle = (checked) => {
    updateIsUserCheckedInData("isOtherLocation", checked);
  };


  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setToaster(
            "Success!!!",
            `Location ${position.coords.latitude}, ${position.coords.longitude}`,
            "primary"
          );
          // Calling our data from backend if user provide permission... Getting user id from local storage
          fetchLeaveFunc(secureLocalStorage.getItem("id"), setToaster);
          getUserCheckedInStatusFunc(setToaster);
        },
        (error) => {
          console.error("Error getting the user location:", error);
          setToaster("Error!!!", "Location permission required", "danger");
        },
        {
          enableHighAccuracy: true, // Use GPS if available
          timeout: 5000, // Timeout in milliseconds
          maximumAge: 0 // Always fetch a fresh location
        }


      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setToaster(
        "Error!!!",
        "Geolocation is not supported by this browser.",
        "danger"
      );
    }
    getUserCheckedInStatusFunc(setToaster);
  }, [modalShown]);

  // Function to validate if the user's location is within the allowed area
  const validateLocation = () => {
    return true;
    // TO DO: we are working on a external api for location validation
    // if (isUserCheckedInData.isWFH) {
    //   return true;
    // }
    // const userLocation = { latitude, longitude };
    // // Define office locations
    // const officeLocations = {
    //   // malad- 19.184737556776877, 72.82994716834767
    //   // thane - 19.19826598611238, 72.94876475966693
    //   //fusion-mumbai - 19.1108256701588, 73.01607380935081
    //   // techno-task-thane-west-mumbai - 19.198953531829233, 72.95399819770618
    //   //fusionKolkata - 22.574302157035824, 88.43569476099319
    //   thane: { latitude: 19.198295418852734, longitude: 72.94904697214402 },
    //   malad: { latitude: 19.184737556776877, longitude: 72.82994716834767 },
    //   cnxMunbai: { latitude: 19.180499415014236, longitude: 72.83236366703203 },
    //   squadStackMumbai: {
    //     latitude: 19.075751940107427,
    //     longitude: 73.01943812158802,
    //   },
    //   fusionKolkata: {
    //     latitude: 22.574302157035824,
    //     longitude: 88.43569476099319,
    //   },
    //   fusionMumbai: {
    //     latitude: 19.1108256701588,
    //     longitude: 73.01607380935081,
    //   },
    //   technoTask: {
    //     latitude: 19.198953531829233,
    //     longitude: 72.95399819770618,
    //   },

    //   // blr as a default location for all other locations

    //   BLR: { latitude: 12.911708, longitude: 77.60186701777795 },

    //   // Add other office locations as needed
    // };

    // let selectedOffice = "BLR";

    // if (leaveData.location) {
    //   const trimmedLocation = leaveData.location
    //     .replace(/\s/g, "")
    //     .trim()
    //     .toLowerCase();
    //   switch (trimmedLocation) {
    //     case "malad":
    //       selectedOffice = "malad";
    //       break;
    //     case "thane":
    //       selectedOffice = "thane";
    //       break;
    //     case "cnxmumbai":
    //       selectedOffice = "cnxMumbai";
    //       break;
    //     case "squadstacksmumbai":
    //       selectedOffice = "squadStackMumbai";
    //       break;
    //     case "fusionkolkata":
    //       selectedOffice = "fusionKolkata";
    //       break;
    //     case "fusionmumbai":
    //       selectedOffice = "fusionMumbai";
    //       break;
    //     case "technotaskmumbai":
    //       selectedOffice = "technoTask";
    //       break;
    //     default:
    //       selectedOffice = "BLR";
    //       break;
    //   }
    // }

    // // If user's location matches any office location, validate against that office's coordinates
    // if (selectedOffice && userLocation.latitude && userLocation.longitude) {
    //   const officeCoords = officeLocations[selectedOffice];
    //   const distance = getDistanceFromLatLonInKm(
    //     officeCoords.latitude,
    //     officeCoords.longitude,
    //     userLocation.latitude,
    //     userLocation.longitude
    //   );

    //   if (distance <= 1) {
    //     // Modify this radius according to your requirements
    //     return true; // User's location is within the allowed area
    //   }
    // }
    // return false;
  };

  // const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  //   const R = 6371;
  //   const dLat = deg2rad(lat2 - lat1);
  //   const dLon = deg2rad(lon2 - lon1);
  //   const a =
  //     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //     Math.cos(deg2rad(lat1)) *
  //     Math.cos(deg2rad(lat2)) *
  //     Math.sin(dLon / 2) *
  //     Math.sin(dLon / 2);
  //   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //   const d = R * c;
  //   return d;
  // };

  // const deg2rad = (deg) => {
  //   return deg * (Math.PI / 180);
  // };

  // Updated handleCheckInOut function to include location validation
  const handleCheckInOut = (isCheckIn, selectedOffice) => {
    if (validateLocation()) {
      // Check if user is in valid location or if they are WFH
      setToaster(
        "Success",
        `You are at the ${selectedOffice} location`,
        "success"
      );
      userCheckedInOutFunc(isUserCheckedInData.isWFH, isCheckIn, isUserCheckedInData.isOtherLocation, setToaster);
    } else {
      setToaster(
        "Error!!!",
        "You are not at the required location to check-in/out",
        "danger"
      );
    }
  };

  const handleUpdateLeave = async () => {
    try {
      if (!requestLeaveRange) {
        setToaster("Error!!!", "Please Select Start and End Date", "danger");
        return;
      }
      if (comments.length === 0) {
        setToaster("Error!!!", "Please add comments", "danger");
        return;
      }
      if (selectedLeave.length === 0) {
        setToaster("Error!!!", "Please Select Leave Type", "danger");
        return;
      }
      const date1 = requestLeaveRange[0];
      const date2 = requestLeaveRange[1];
      const response = await applyLeave(secureLocalStorage.getItem("id"), {
        leaveId: selectedLeave,
        leaveStartDate: date1,
        leaveEndDate: date2,
        leaveReason: comments,
      });
      fetchLeaveFunc(secureLocalStorage.getItem("id"), setToaster);
      setToaster("Success!!!", response.data.message, "success");
      onCancelRequestLeaveModal()
    } catch (error) {
      setToaster("Error!!!", error?.response?.data?.message, "danger");
    }
  };

  const onCancelRequestLeaveModal = () => {
    setComments("");
    setLeaveModalToggle();
    setRequestLeaveRange(null);
  };

  const descriptionData = [
    {
      key: "1",
      label: "Name",
      children: leaveData.userName || "NA",
    },
    {
      key: "2",
      label: "Shift",
      children: leaveData.shift || "NA",
    },
    {
      key: "3",
      label: "Reporting Manager",
      children: leaveData.reportingManager || "NA",
    },
    {
      key: "4",
      label: "Status",
      children: leaveData.currentStatus || "NA",
    },
    {
      key: '5',
      label: 'Location',
      children: leaveData.location || "NA",
    }
  ];

  const disabledAllLeavesDate = (current) => {
    // Get today's date
    const todayStart = dayjs().startOf("day");
    const todayEnd = dayjs().endOf("day");
    // Get the date 7 days before today
    const past7Days = todayStart.subtract(8, "day");
    // Get the date 21 days after today
    const future21Days = todayStart.add(21, "day");
    if (isUserCheckedInData.isUserCheckedIn.toString() === "false") {
      return (current <= past7Days || current > future21Days);
    }
    return current && current <= past7Days || current >= todayStart && current <= todayEnd || current > future21Days;
  };

  const disabledForWeekOffsDate = (current) => {
    // Get today's date
    const todayStart = dayjs().startOf("day");
    const todayEnd = dayjs().endOf("day");
    // Define the past 7 days range
    const past7Days = todayStart.subtract(7, "day");
    // Define future 15 days range
    const future15Days = todayStart.add(15, "day");
    
    if (isUserCheckedInData.isUserCheckedIn.toString() === "false") {
      // Enable dates within the past 7 days and future 15 days for checked-in users as well
      return current && (current < past7Days || current > future15Days);
    }

    return current && current >= todayStart && current <= todayEnd || current < past7Days || current > future15Days;
  };  

  // const checkInOutToggle = (isCheckedIn) => {
  //   userCheckedInOutFunc(isUserCheckedInData.isWFH, isCheckedIn, setToaster);
  // }
  // const checkInOutToggle = (isCheckedIn) => {
  //   userCheckedInOutFunc(isUserCheckedInData.isWFH, isCheckedIn, setToaster);
  // }
  const now = moment();
  const eightAM = moment().startOf('day').add(7, 'hours');
  const sixPM = moment().startOf('day').add(18, 'hours');
  const checkInOutToggle = (isCheckedIn) => {
    if(isCheckedIn === false && now.isAfter(eightAM) && now.isBefore(sixPM)){
      if(secureLocalStorage.getItem('user_clockout_confirmed') === 'true'){
        handleCheckInOut(isCheckedIn, leaveData.location);
        secureLocalStorage.removeItem('user_clockout_confirmed');
      }else{
        setModalShown(true);
      }
    }else{
      handleCheckInOut(isCheckedIn, leaveData.location);
    }
  };

  return (
    <>
      {modalShown ? <ClockOutConfirm setModalShown={setModalShown} /> : <></>}
      <CardDiv
        title={<h3 className="fw-bold">Leave Tracker</h3>}
        component={
          <div style={{ minHeight: "80vh" }}>
            {/* Heading */}
            <div className="d-flex justify-content-between m-5">
              <h3 className="">Leave Balance</h3>
              <div className="d-flex flex-column" style={{ width: "150px" }}>

                {leaveData?.leaveDetails?.length !== 0 && (
                  <Button
                  type="primary"
                  onClick={setCheckInOutModalToggle}
                  className="fw-bold"
                  disabled={
                    !isUserCheckedInData?.isUserCheckedIn && // User is not checked in
                    (now.isBefore(eightAM) || now.isAfter(sixPM)) // Disable check-in before 8 AM and after 6 PM
                  }
                >
                  {isUserCheckedInData.isUserCheckedIn ? "Check Out" : "Check In"}
                </Button>                
                )}

              </div>
            </div>

            {/* If No permission allowed showing this empty window. */}
            {leaveData?.leaveDetails?.length === 0 && (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ minHeight: "50vh" }}
              >
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  imageStyle={{ height: 60 }}
                  description={<span> Please allow Location permission </span>}
                >
                  <Button
                    onClick={() => window.location.reload()}
                    type="primary"
                  >
                    Refresh Now
                  </Button>
                </Empty>
              </div>
            )}

            {/* Description of the current user */}
            <div className="d-flex justify-content-between m-5">
              {leaveData?.leaveDetails?.length !== 0 && (
                <Descriptions
                  title="User Description"
                  items={descriptionData}
                />
              )}
            </div>

            {/* Leave Cards */}
            <div className="px-5">
              <Space
                direction="horizontal"
                size={25}
                className="flex-wrap justify-content-around"
              >
                {leaveData?.leaveDetails?.map((leave) => (
                  <CardBox
                    key={leave.leaveId}
                    name={leave.leaveName}
                    leaveId={leave.leaveId}
                    leaveLabel={leave.leaveLabel}
                    annualLeaveCount={leave.annualLeaveCount}
                    leaveBalance={leave.leaveBalance}
                    leaveConsumed={leave.leaveConsumed}
                    description={leave.description}
                  />
                ))}
              </Space>
            </div>

            {/* Added Request Leave Modal */}
            <Modal
              open={isLeaveModalOpen}
              title={<h3 className="">Request Leave</h3>}
              onCancel={onCancelRequestLeaveModal}
              footer={[
                <Button
                  key="submit"
                  type="primary"
                  loading={isLoading}
                  onClick={handleUpdateLeave}
                >
                  {" "}
                  Submit{" "}
                </Button>,
              ]}
            >
              <div className="w-100 d-flex flex-column gap-5 py-5">
                <div className="row">
                  <h4 className="col-4 fs-1">Select Date</h4>
                  <RangePicker
                    className="col-8"
                    value={requestLeaveRange}
                    format={{ format: "YYYY-MM-DD" }}
                    onChange={setRequestLeaveRange}
                    disabledDate={
                      selectedLeave === "663ddaab91327db4b42990fc"
                        ? disabledForWeekOffsDate
                        : disabledAllLeavesDate
                    }
                  />
                </div>
                <div className="row">
                  <h4 className="col-4 fs-1">Type of leave</h4>
                  <Select
                    className="col-7"
                    value={selectedLeave}
                    disabled
                    onChange={setSelectedLeave}
                  >
                    {leaveData.leaveDetails.map((leave) => (
                      <Option key={leave.leaveId} value={leave.leaveId}>
                        {leave.leaveName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="w-100">
                  <TextArea
                    placeholder="Leave Comments"
                    autoSize={{ minRows: 2, maxRows: 6 }}
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </div>
              </div>
            </Modal>

            {/* Added Check In Modal */}
            <Modal
              open={isCheckInOutModalOpen}
              onCancel={setCheckInOutModalToggle}
              footer={false}
            >
              <div className="d-flex gap-3 align-content-center">
                <h4 className="pt-1">Check - IN | Check - Out</h4>
                {isUserCheckedInData.isWFH
                  &&
                  <span class="badge rounded-pill text-bg-primary align-self-center">Work From Home</span>
                }
              </div>
              <div className="w-100 d-flex flex-column gap-5 align-items- justify-content-center py-5">
                <Row gutter={20}>
                  <Col span={12}>
                    {isUserCheckedInData.isUserCheckedIn ? (
                      <Card
                        bordered={false}
                        style={{ backgroundColor: "#f0f8ff" }}
                      >
                        <Statistic
                          title={<span className="fw-bold">Check - In</span>}
                          value={isUserCheckedInData.shiftStartTime}
                          style={{ width: "150px" }}
                          prefix={<ArrowUpOutlined />}
                          valueStyle={{
                            color: "#3f8600",
                          }}
                        />
                      </Card>
                    ) : (
                      <Tooltip
                        title="Click to Check In Attendance"
                        color={"cyan"}
                      >
                        <Card
                          bordered={false}
                          style={{ cursor: "pointer" }}
                          hoverable={false}
                          onClick={() => checkInOutToggle(true)}
                        >
                          <Statistic
                            title={<span className="fw-bold">Check - In</span>}
                            value={isUserCheckedInData.shiftStartTime}
                            style={{ width: "150px" }}
                            prefix={<ArrowUpOutlined />}
                            valueStyle={{
                              color: "#3f8600",
                            }}
                          />
                        </Card>
                      </Tooltip>
                    )}
                  </Col>
                  <Col span={12}>
                    {isUserCheckedInData.isUserCheckedIn ? (
                      <Tooltip
                        title="Click to Check Out Attendance"
                        color={"pink"}
                      >
                        <Card
                          bordered={false}
                          style={{ cursor: "pointer" }}
                          hoverable={true}
                          onClick={() => checkInOutToggle(false)}
                        >
                          <Statistic
                            title={<span className="fw-bold">Check - Out</span>}
                            value={isUserCheckedInData.shiftEndTime}
                            style={{ width: "150px" }}
                            prefix={<ArrowDownOutlined />}
                            valueStyle={{ color: "#cf1322" }}
                          />
                        </Card>
                      </Tooltip>
                    ) : (
                      <Card
                        bordered={false}
                        style={{ backgroundColor: "#f0f8ff" }}
                      >
                        <Statistic
                          title={<span className="fw-bold">Check - Out</span>}
                          value={isUserCheckedInData.shiftEndTime}
                          style={{ width: "150px" }}
                          prefix={<ArrowDownOutlined />}
                          valueStyle={{ color: "#cf1322" }}
                        />
                      </Card>
                    )}
                  </Col>
                </Row>
              </div>
            </Modal>
          </div>
        }
      />
    </>
  );
};

export default LeaveTracker;

const CardBox = (props) => {
  // Importing required zustand State
  const {
    isLoading,
    selectedLeave,
    setSelectedLeave,
    leaveData,
    isLeaveModalOpen,
    setLeaveModalToggle,
  } = useLeaveBalancePageState();

  return (
    <>
      <Card
        className="d-flex flex-column gap-5"
        style={{ width: 400, height: 300 }}
        title={
          <>
            <div className="d-flex flex-column ">
              <h5 className="fw-bold">
                {props.name} ({props.leaveLabel})
              </h5>
              <p className="fw-lighter m-0" style={{ fontSize: "12px" }}>
                {props.description}
              </p>
            </div>
          </>
        }
      >
        <div className="col d-flex flex-column gap-5">
          <div className="row">
            <div className="d-flex">
              <div className="d-flex flex-column align-items-center justify-content-center w-50 fw-bolder">
                <span>Available</span>
                <span>{props.leaveBalance || 0} Day</span>
              </div>
              <div className="d-flex flex-column align-items-center justify-content-center w-50 fw-bolder">
                <span>Consumed</span>
                <span>{props.leaveConsumed || 0} Day</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="d-flex">
              <div className="d-flex flex-column align-items-center justify-content-center w-50 fw-bolder">
                <span>Annual Quota</span>
                <span>{props.annualLeaveCount || 0} Days</span>
              </div>
              <div className="d-flex flex-column align-items-center justify-content-center w-50 fw-bolder">
                <Button
                  disabled={
                    props.leaveLabel !== "CO" &&
                    props.leaveLabel !== "UL" &&
                    props.leaveBalance < 1
                  }
                  className="fw-bolder btn btn-primary"
                  onClick={() => {
                    setLeaveModalToggle();
                    setSelectedLeave(props.leaveId);
                  }}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
